/**
 * PLP -Search & Results -Null Search development
 */

import { LocalizationWithComponent } from '@/components/blocks/LocalizationWithComponent';
import { zeroResultsSx } from '@/components/content/CatalogEntryList/styles/zeroResults';
import { useNextRouter } from '@/data/Content/_NextRouter';
import { useLocalization } from '@/data/Localization';
import { Box, Button, List, ListItem, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { SEARCH } from 'shared/custom/constants/routes';

const boldComponent = [<b key="b" />];

type props = {
	searchTerm: string;
	searchSuggestion?: string;
	suggestions?: string[];
};

export const CatalogEntryListZeroResults: FC<props> = ({
	searchTerm,
	searchSuggestion,
	suggestions,
}) => {
	const router = useNextRouter();
	const { noMatches, searchTips, searchTipsLabels, showingResultsFor, searchInstead } =
		useLocalization('ProductGrid').Labels;

	const handleClick = (suggestion: string) => {
		router.push(`${SEARCH}/${suggestion}`);
	};

	const searchTipsList = [
		searchTipsLabels.trySearchNameBrand.t(),
		searchTipsLabels.useAdjetives.t(),
		searchTipsLabels.checkSpelling.t(),
		searchTipsLabels.trySynonyms.t(),
	].map((str) => (
		<ListItem key={str} disablePadding sx={zeroResultsSx.listItem}>
			<Typography>{str}</Typography>
		</ListItem>
	));

	return (
		<Stack sx={zeroResultsSx.root}>
			<Box>
				<Typography>
					<LocalizationWithComponent
						text={noMatches.t({ searchTerm: searchTerm ?? '' })}
						components={boldComponent}
					/>
				</Typography>
				<Typography>{searchTips.t()}</Typography>
			</Box>
			<List sx={zeroResultsSx.list}>{searchTipsList}</List>
			{searchSuggestion ? (
				<>
					<Typography sx={zeroResultsSx.typografyP}>
						<LocalizationWithComponent
							text={showingResultsFor.t({ searchTerm: searchSuggestion })}
							components={boldComponent}
						/>
					</Typography>
					{suggestions && suggestions.length ? (
						<Stack direction={'row'} alignItems={'center'}>
							<Typography variant="body1" sx={zeroResultsSx.typografyFS}>
								{searchInstead.t()}
							</Typography>
							<Stack direction={'row'} spacing={'10px'} sx={zeroResultsSx.suggestionContainer}>
								{suggestions.map((suggestion) => (
									<Button
										onClick={() => {
											handleClick(suggestion);
										}}
										variant="outlined"
										key={suggestion}
										sx={zeroResultsSx.suggestionButtons}
									>
										{suggestion}
									</Button>
								))}
							</Stack>
						</Stack>
					) : null}
				</>
			) : null}
		</Stack>
	);
};
